export default "__VITE_ASSET__99b95e01__"